import React, { useState } from 'react'
import { useTranslation } from 'react-i18next'

import { sendEmail } from '../../../common/emailService'
import TermsModal from './TermsModal'

function ContactForm() {
  const { t } = useTranslation()
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    phone: '',
    subject: '',
    message: '',
  })
  const [isSubmitting, setIsSubmitting] = useState(false)
  const [alert, setAlert] = useState({ show: false, message: '', type: '' })
  const [isTermsModalOpen, setIsTermsModalOpen] = useState(false)

  const handleChange = (e) => {
    const { name, value } = e.target
    setFormData({ ...formData, [name]: value })
  }

  const handleSubmit = async (e) => {
    e.preventDefault()
    setIsSubmitting(true)

    try {
      await sendEmail(formData)
      setAlert({
        show: true,
        message: 'Email sent successfully! We will get back to you soon.',
        type: 'success',
      })
      // Reset form
      setFormData({
        name: '',
        email: '',
        phone: '',
        subject: '',
        message: '',
      })
    } catch (error) {
      console.error('Email send error:', error)
      setAlert({
        show: true,
        message: 'Failed to send email. Please try again or contact us directly.',
        type: 'error',
      })
    } finally {
      setIsSubmitting(false)
      // Hide alert after 5 seconds
      setTimeout(() => {
        setAlert({ show: false, message: '', type: '' })
      }, 5000)
    }
  }

  const handleTermsClick = (e) => {
    e.preventDefault()
    setIsTermsModalOpen(true)
  }

  const handleCloseModal = () => {
    setIsTermsModalOpen(false)
  }

  return (
    <section className="tc-contact-form-style1">
      <div className="container">
        <div className="row justify-content-between">
          <div className="col-lg-4">
            <div className="info wow fadeInUp slow" data-wow-delay="0.2s">
              <h3 className="fsz-45 fw-500 mb-80 marcellus">{t('contact.formTitle')}</h3>
              <p className="fsz-14 color-666 mt-15 marcellus">
                {t('contact.formSubtitle')} <br />
                <span className="text-danger"> * </span>
              </p>
            </div>
          </div>
          <div className="col-lg-6">
            <form
              onSubmit={handleSubmit}
              className="form mt-5 mt-lg-0 wow fadeInUp slow"
              data-wow-delay="0.4s"
            >
              <div className="row">
                <div className="col-lg-6">
                  <div className="form-group mb-30">
                    <label htmlFor="name">
                      {t('contact.fullName')} <span className="color-brown2"> * </span>
                    </label>
                    <input
                      type="text"
                      id="name"
                      name="name"
                      className="form-control"
                      placeholder={t('contact.namePlaceholder')}
                      value={formData.name}
                      onChange={handleChange}
                      required
                    />
                  </div>
                </div>
                <div className="col-lg-6">
                  <div className="form-group mb-30">
                    <label htmlFor="email">
                      {t('contact.emailAddress')} <span className="color-brown2">*</span>
                    </label>
                    <input
                      type="email"
                      id="email"
                      name="email"
                      className="form-control"
                      placeholder={t('contact.emailPlaceholder')}
                      value={formData.email}
                      onChange={handleChange}
                      required
                    />
                  </div>
                </div>
                <div className="col-lg-6">
                  <div className="form-group mb-30">
                    <label htmlFor="phone">
                      {t('contact.phone')}{' '}
                      <span className="color-999"> {t('contact.optional')} </span>
                    </label>
                    <input
                      type="tel"
                      id="phone"
                      name="phone"
                      className="form-control"
                      placeholder={t('contact.phonePlaceholder')}
                      value={formData.phone}
                      onChange={handleChange}
                    />
                  </div>
                </div>
                <div className="col-lg-6">
                  <div className="form-group mb-30">
                    <label htmlFor="subject">
                      {t('contact.subject')} <span className="color-brown2"> * </span>
                    </label>
                    <select
                      name="subject"
                      id="subject"
                      className="form-select form-control"
                      value={formData.subject}
                      onChange={handleChange}
                      required
                    >
                      <option value="">{t('contact.selectSubject')}</option>
                      <option value="Custom Design">{t('contact.subject1')}</option>
                      <option value="Repair Service">{t('contact.subject2')}</option>
                    </select>
                  </div>
                </div>
                <div className="col-lg-12">
                  <div className="form-group mb-30">
                    <label htmlFor="message">{t('contact.message')}</label>
                    <textarea
                      id="message"
                      name="message"
                      rows="6"
                      placeholder={t('contact.messagePlaceholder')}
                      className="form-control"
                      value={formData.message}
                      onChange={handleChange}
                      required
                    ></textarea>
                  </div>
                </div>
              </div>

              {/* Alert Notification */}
              {alert.show && (
                <div
                  className={`alert ${alert.type === 'success' ? 'alert-success' : 'alert-danger'} mb-3`}
                  role="alert"
                >
                  <div className="d-flex align-items-center">
                    <i
                      className={`fas ${alert.type === 'success' ? 'fa-check-circle' : 'fa-exclamation-triangle'} me-2`}
                    ></i>
                    {alert.message}
                  </div>
                </div>
              )}

              <button
                type="submit"
                disabled={isSubmitting}
                className="butn hover-bg-brown2 text-capitalize bg-white rounded-pill mt-40 marcellus"
              >
                <span>
                  {isSubmitting ? 'Sending...' : t('contact.sendMessage')}
                  <i className="fal fa-arrow-up-right ms-2"></i>
                </span>
              </button>
              <p className="fsz-12 color-666 mt-20">
                {t('contact.termsAgreement')}{' '}
                <a
                  href="#"
                  className="color-000 text-decoration-underline"
                  onClick={handleTermsClick}
                >
                  {t('contact.termsConditions')}
                </a>
              </p>
            </form>
          </div>
        </div>
      </div>
      <img src="/assets/images/gallery/portfolio/contact_shape.png" alt="" className="shap" />

      <TermsModal isOpen={isTermsModalOpen} onClose={handleCloseModal} />
    </section>
  )
}

export default ContactForm
